import { Form } from "antd";
import SelectCustom from "../../../Common/SelectCustom/SelectCustom";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import MobilyLogo from "../../../../assets/MobilyLogo.svg";
import RadioCustom from "../../../Common/RadioCustom/RadioCustom";
import InputCustom from "../../../Common/InputCustom/InputCustom";
import CheckboxCustom from "../../../Common/CheckboxCustom/CheckboxCustom";
import { getProductType } from "../../../../api/api";
import { prefixSelector } from "../../../Util/Util";
import mobilyODBSample from "../../../../assets/mobily-sample.svg";

const SIP: React.FC<any> = () => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const { rtl, productType, userType, productFormData, cities, productBackListData, isSIPformTouched } = state;
    console.log(rtl, 'rtl')
    const [packageNameOptions, setPackageNameOptions] = useState([]);
    const [hasMobilyODB, setHasMobilyODB] = useState(false)
    const [productDataAll, setProductDataAll] = useState([]);
    const [isFormValid, setIsFormValid] = useState(isSIPformTouched);
    const [selectedPackage, setSelectedPackage] = useState<any>(productBackListData?.[0]?.productInformation?.packageName ? productBackListData[0].productInformation.packageName : {});
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const dir = rtl ? 'right' : 'left';
    const initialValues = {
      SIP_Trunk_Package: productFormData.SIP_Trunk_Package ? productFormData.SIP_Trunk_Package : '',
      installed: productFormData.installed ? productFormData.installed : '',
      ODBNumber: productFormData.ODBNumber ? productFormData.ODBNumber : '',
      city: productFormData.city ? productFormData.city : '',
      longitude: productFormData.longitude ? productFormData.longitude : '',
      latitude: productFormData.latitude ? productFormData.latitude : '',
      IPPBX: productFormData.IPPBX ? productFormData.IPPBX : '',
      IPPBXDevice: productFormData.IPPBXDevice ? productFormData.IPPBXDevice : '',
      telephoneDevice: productFormData.telephoneDevice ? productFormData.telephoneDevice : '',
      NumberOfDevices: productFormData.NumberOfDevices ? productFormData.NumberOfDevices : '',
      telecomEquipment: productFormData.telecomEquipment ? productFormData.telecomEquipment : '',
      fullName: productFormData.fullName ? productFormData.fullName : '',
      mobileNumber: productFormData.mobileNumber ? productFormData.mobileNumber : '',
      accept: productFormData.accept ? productFormData.accept : '',
      prefix: productFormData.prefix ? productFormData.prefix : '966',
    };

    useEffect(() => {
      dispatch({ type: "LOADER", payload: { loading: true } });

      getProductType('DIG_FIBER_SIP_PKG').then((res) => {
        const productOpt: any = res.data;
        setProductDataAll(productOpt.data);
        const packageOption = [];
        productOpt.data.products_list.sort((a: any, b: any) => parseInt(a.order_priority) - parseInt(b.order_priority))
        for (let i = 0; i < productOpt.data.products_list.length; i++) {
          if (productOpt.data.products_list[i].product_type === "SIP") {
            const opt = {
                value: "",
                name: "",
                productName: "",
                price: '',
                text: ''
            };
            opt.name = opt.value = opt.text = rtl
              ? (productOpt.data.products_list[i].product_name_ar)
              : (productOpt.data.products_list[i].product_name_en);
            opt.price = productOpt.data.products_list[i].mrc;
            packageOption.push(opt);
          }
        }
        setPackageNameOptions(packageOption);
      })
      dispatch({ type: "LOADER", payload: { loading: false } });
    }, [dispatch, rtl, t]);

    const handlePackageChange = (value: any, formName: string, fieldName: string) => {
      form.setFieldValue(fieldName, value);
      if (fieldName === 'packageName') {
        const jsonResData: any = productDataAll;
        const packageResponse = jsonResData.products_list.filter((res: any) => rtl ? res.product_name_ar === value : res.product_name_en === value)[0];
        if (packageResponse) {
          const packageData: any = {};
          packageData.price = packageResponse.mrc;
          packageData.mrc = packageResponse.mrc;
          packageData.nrc = packageResponse.nrc;
          packageData.mode_sfaId = packageResponse.mode_sfa_id;
          packageData.product_Id = packageResponse.product_id;
          packageData.packageType_sfaId = packageResponse.package_type_sfa_id;
          packageData.name = value;
          setSelectedPackage(packageData);
        } else {
          form.setFields([
            {
              name: 'quantity',
              value: '',
              errors: [t('Package_Not_Available')],
            }
          ])
        }
      }
    };
    const onValuesChange = useCallback(() => {
      setTimeout(async ()=>{
          setIsFormValid((form.isFieldsTouched(["SIP_Trunk_Package", "installed", "IPPBX", "telephoneDevice", "telecomEquipment", "accept", "city"], true) || isSIPformTouched) && form.getFieldsError().filter(({ errors }) => errors.length).length === 0)
          try {
            if (form.isFieldsTouched(["SIP_Trunk_Package", "installed", "IPPBX", "telephoneDevice", "telecomEquipment", "accept", "city"], true)) {
              await form.validateFields();
            }
          } catch (err) {
            setIsFormValid(false)
          }
      }, 0);
    }, [form, isSIPformTouched]);
    const handleNext = async (values: any) => {
      try {
        const res = await form.validateFields();
        const newList = [{
          productInformation: {
            productType: { value: productType },
            ODBOperator: { value: res.ODBOperator},
            ODBNumber: { value: res.ODBNumber},
            city: { value: res.city},
            longitude: { value: res.longitude},
            latitude: { value: res.latitude},
            fullName: { value: res.fullName},
            mobileNumber: { value: res.mobileNumber },
            quantity: { value: 1 },
            packageName: { ...selectedPackage, value: res.packageName },
            installed: res.installed,
            IPPBX: res.IPPBX,
            telephoneDevice: res.telephoneDevice,
            telecomEquipment: res.telecomEquipment,
          }
        }];
        dispatch({
          type: "PRODUCT_INFORMATION",
          payload: {
            values: newList,
            productList: newList,
            page: t("Download_Attach"),
            modalOpen: userType === 'newcustomer' ? false : true,
            productFormData: res
          }
        });
      } catch (error) {
        console.log(error);
      }
    }

    return (
        <div className="row">
            <div className="col-md-8">
                <Form form={form} name="accordionForm" initialValues={initialValues} onFinish={handleNext} onValuesChange={onValuesChange}>
                    <SelectCustom
                        headingLeft={t('SIP_Trunk_Package')}
                        name="SIP_Trunk_Package"
                        options={packageNameOptions}
                        placeholder={t(`Choose_SIP_package`)}
                        handleChange={(value: any) => {
                          handlePackageChange(value, "productInformation", "packageName");
                        }}
                        rules={[
                            { required: true, message: `${t("Please_Enter")} ${t("SIP_Trunk_Package")}` },
                        ]}
                    />
                    <Typography rtl={rtl} fontSize="32px" fontWeight="700" fontFamily="ScandiaWeb-Bold">{t('Location_Technical_Details')}</Typography>
                    <Typography rtl={rtl} fontSize="16px" fontWeight="400" className="mb-3">{t('Location_Technical_Description')}</Typography>
                    <RadioCustom
                      dir={dir}
                      headingleft={t("SIP_Already_Installed_Qs")}
                      name="installed"
                      options={[{value: 'yes', label: t('yes')},{value: 'no', label: t('no')}]}
                      rules={[{ required: true, message: `${t("Mandatory_Field")}`}]}
                      onChange={(e: any)=>{
                        setHasMobilyODB(e.target.value==='yes' ? true : false)
                      }}
                    />
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) => prevValues.installed !== currentValues.installed}
                    >
                      {({ getFieldValue }) => {
                        const installed = getFieldValue('installed');
                        return  installed ? (
                          <>
                            {installed === 'yes' &&
                              <>
                                <div className="d-flex">
                                  <img src={MobilyLogo} alt="MobilyLogo" />
                                  <Typography className="ms-2">{t('Mobily')}</Typography>
                                </div>
                                <InputCustom
                                  rtl={rtl}
                                  maxLength={25}
                                  headingleft={t("ODB_Number")}
                                  name="ODBNumber"
                                  rules={[{ required: true, message: `${t("Please_Enter")} ${t("ODB_Number")}` }]}
                                  placeholder="XXX-YYYY-0000-01"
                                />
                              </>
                            }
                            <SelectCustom
                              headingLeft={t("City")}
                              name="city"
                              options={cities}
                              placeholder={t(`Choose_City`)}
                              rules={[
                                  { required: true, message: `${t("Please_Enter")} ${t("City")}` },
                              ]}
                            />
                            <InputCustom
                              rtl={rtl}
                              maxLength={13}
                              headingleft={t("Longitude")}
                              name="longitude"
                              rules={[{ required: true, message: `${t("Please_Enter")} ${t("Longitude")}` }]}
                              placeholder={`eg. 24°42'29"N or 24.70828964645712`}
                            />
                            <InputCustom
                              rtl={rtl}
                              maxLength={13}
                              headingleft={t("Latitude")}
                              name="latitude"
                              rules={[{ required: true, message: `${t("Please_Enter")} ${t("Latitude")}` }]}
                              placeholder={`eg. 46°40'31"E  or  46.67543543191265`}
                            />
                          </>
                        ) : null
                      }}
                    </Form.Item>
                    <RadioCustom
                      headingleft={t("IPPBX_Device_Ready")}
                      name="IPPBX"
                      options={[{value: 'yes', label: t('yes')},{value: 'no', label: t('no')}]}
                      rules={[{ required: true, message: `${t("Mandatory_Field")}`}]}
                      dir={dir}
                    />
                    <RadioCustom
                      headingleft={t("Telephone_Device_Available")}
                      name="telephoneDevice"
                      options={[{value: 'yes', label: t('yes')},{value: 'no', label: t('no')}]}
                      rules={[{ required: true, message: `${t("Mandatory_Field")}`}]}
                      dir={dir}
                    />
                    <RadioCustom
                      headingleft={t("Telecom_Equipment_Room_Ready")}
                      name="telecomEquipment"
                      options={[{value: 'yes', label: t('yes')},{value: 'no', label: t('no')}]}
                      rules={[{ required: true, message: `${t("Mandatory_Field")}`}]}
                      className="mb-2"
                      dir={dir}
                    />
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) => prevValues.telecomEquipment !== currentValues.telecomEquipment}
                    >
                      {({ getFieldValue }) => {
                        return getFieldValue('telecomEquipment') === 'no' ?
                        <Typography rtl={rtl} fontWeight="700" fontSize="16px" color="#000000" className="mb-3">{t('Equipment_Room_Must_Ready')}</Typography>
                        : null
                      }}
                       </Form.Item>
                    <Typography rtl={rtl} fontSize="32px" fontWeight="700" fontFamily="ScandiaWeb-Bold">{t('Technical_Contact')}</Typography>
                    <Typography rtl={rtl} fontSize="16px" fontWeight="400" className="mb-3">{t('Technical_Contact_Description')}</Typography>
                    <InputCustom
                      rtl={rtl}
                      headingleft={t("Full_Name")}
                      name="fullName"
                      placeholder={t("Enter_full_name")}
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("Full_Name")}` },
                          { pattern: /^[\u0621-\u064A0-9a-zA-Z\s]{2,50}$/, message: t("Verify_entered_data") }
                      ]}
                    />
                    <InputCustom
                      rtl={rtl}
                      headingleft={t("Mobile_Number")}
                      placeholder={t("Enter_phone_number")}
                      name="mobileNumber"
                      prefixSelector={prefixSelector()}
                      maxLength={9}
                      rules={[
                          { required: true, message: `${t("Please_Enter")} ${t("Mobile_Number")}` },
                          { pattern: /^((5)([0-9]{8})){0,9}$/, message: t("Verify_entered_info") }
                      ]}
                    />
                    <CheckboxCustom
                      rtl={rtl}
                      headingleft={t('SIP_Product_Aggrement')}
                      name="accept"
                      rules={[
                        {
                          validator: (_: any, value: any) =>
                            value ? Promise.resolve() : Promise.reject('You must accept the terms!'),
                        },
                      ]}
                    />
                    <IconButton width={"130px"} htmlType='submit' rtl={rtl} className={`next-button mt-2 ${isFormValid ? '' : 'disabled'}`}>
                        {t("Next")}
                    </IconButton>
                </Form>
            </div>
            {hasMobilyODB && <div className="col-sm-4 text-center">
              <img src={mobilyODBSample} alt='sample' height={243} width={176}/>
            </div>}
        </div>
    )
}

export default SIP;
